import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const services = [
  {
    icon: 'FiTarget',
    title: 'Corporate Strategy',
    desc: 'Redefining corporate vision and portfolio strategy to unlock new avenues of growth and profitability.'
  },
  {
    icon: 'FiCpu',
    title: 'Digital Transformation',
    desc: 'Leveraging AI, cloud, and modern architecture to build agile, data-driven enterprises.'
  },
  {
    icon: 'FiBriefcase',
    title: 'Mergers & Acquisitions',
    desc: 'End-to-end M&A advisory, from target screening and due diligence to post-merger integration.'
  },
  {
    icon: 'FiTrendingUp',
    title: 'Operations & Performance',
    desc: 'Optimizing supply chains, reducing costs, and improving organizational efficiency at scale.'
  },
  {
    icon: 'FiShield',
    title: 'Risk & Compliance',
    desc: 'Navigating complex regulatory landscapes and building resilient risk management frameworks.'
  },
  {
    icon: 'FiGlobe',
    title: 'Sustainability & ESG',
    desc: 'Integrating environmental, social, and governance principles into core business strategies.'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-amber-600 font-semibold tracking-wider uppercase text-sm mb-3">Our Expertise</h2>
            <h3 className="text-4xl md:text-5xl font-serif text-slate-900 leading-tight">
              Capabilities designed for the modern enterprise.
            </h3>
          </div>
          <button className="text-slate-900 font-medium flex items-center gap-2 group hover:text-amber-600 transition-colors whitespace-nowrap">
            View All Services
            <SafeIcon icon={FiIcons.FiArrowRight} className="transition-transform group-hover:translate-x-1" />
          </button>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {services.map((service, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="mb-6 p-4 bg-slate-50 inline-block text-slate-800 group-hover:bg-slate-900 group-hover:text-amber-500 transition-colors duration-300">
                <SafeIcon name={service.icon} className="w-8 h-8 stroke-[1.5]" />
              </div>
              <h4 className="text-xl font-serif font-bold text-slate-900 mb-3 group-hover:text-amber-600 transition-colors">
                {service.title}
              </h4>
              <p className="text-slate-600 leading-relaxed">
                {service.desc}
              </p>
              <div className="mt-4 w-12 h-0.5 bg-slate-200 group-hover:w-full group-hover:bg-amber-600 transition-all duration-500"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}